import React, {useRef, useState, ReactNode} from 'react';
import {IonPopover} from '@ionic/react';
import InfoImg from '@assets/images/info.svg';
import {StyledInfoImage} from "@components/info/info.style";
import {StyledPopoverContent} from "@components/popover/popover.styles";

interface InfoPopoverProps {
    content: ReactNode;
}

const InfoPopover: React.FC<InfoPopoverProps> = ({content}) => {
    const popover = useRef<HTMLIonPopoverElement>(null);

    const [isOpen, setIsOpen] = useState(false);
    const [event, setEvent] = useState<MouseEvent | undefined>(undefined);

    return (
        <>
            <IonPopover
                ref={popover}
                isOpen={isOpen}
                onDidDismiss={() => setIsOpen(false)}
                event={event}
            >
                <StyledPopoverContent>{content}</StyledPopoverContent>
            </IonPopover>
            <StyledInfoImage
                src={InfoImg}
                onClick={(e) => {
                    e.stopPropagation();

                    setEvent(e.nativeEvent);
                    setIsOpen(true);
                }}
            />
        </>
    );
};

export default InfoPopover;